export default {
  mobile_app_average_order_value: {
    label: 'AOV via App',
  },
  mobile_app_gmv: {
    label: 'Vendite App',
  },
  mobile_app_gmv_percentage: {
    label: '% ricavi via App',
  },
  mobile_app_downloads: {
    label: 'Download',
  },
  mobile_app_orders_count: {
    label: 'Ordini App',
  },
  name: {
    label: 'Ristorante',
  },
  mobile_app_released_at: {
    label: 'Data di lancio',
  },
  title: 'Directory ristoranti',
};
